/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum indicating types of pricing.
 */
export enum PricingType {
    RGI = 'RGI',
    SUPPORT = 'Support',
    MARKET = 'Market',
}
